export enum DeliveryProductType {
  FullVersion,
  ServiceRelease,
  Hotfix,
}
